import React from 'react';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { ConfigSchema, ConfigValues } from '../schema/schema';
import SchemaForm from '../components/SchemaForm';
import ConfigMigrateBanner from '../components/ConfigMigrateBanner';
import { useI18n } from '../i18n';

interface SettingsFormDialogProps {
  open: boolean;
  schema: ConfigSchema;
  values: ConfigValues;
  raw: string;
  disabled?: boolean;
  pushWarning?: boolean;
  onClose: () => void;
  onChange: (values: ConfigValues) => void;
  onMigrated: (raw: string) => void;
}

const SettingsFormDialog: React.FC<SettingsFormDialogProps> = ({
  open,
  schema,
  values,
  raw,
  disabled,
  pushWarning,
  onClose,
  onChange,
  onMigrated,
}) => {
  const { t } = useI18n();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle>{t('files.settingsFormTitle')}</DialogTitle>
      <DialogContent dividers>
        {pushWarning && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            {t('files.settingsPushWarning')}
          </Alert>
        )}
        <ConfigMigrateBanner
          schema={schema}
          raw={raw}
          disabled={disabled}
          onMigrated={onMigrated}
        />
        <Box sx={{ mt: 1 }}>
          <SchemaForm
            schema={schema}
            values={values}
            onChange={onChange}
            disabled={disabled}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsFormDialog;
